const TOKEN_KEY = "isAuthenticated";
const parse = JSON.parse;

const auth = {
  /**
   * Returns data from storage
   * @param  {String} key Item to get from the storage
   * @return {String|Object}     Data from the storage
   */
  get(key) {
    if (localStorage && localStorage.getItem(key)) {
      return parse(localStorage.getItem(key)) || null;
    }

    if (sessionStorage && sessionStorage.getItem(key)) {
      return parse(sessionStorage.getItem(key)) || null;
    }

    return null;
  },
  getToken(tokenKey = TOKEN_KEY) {
    return auth.get(tokenKey);
  }
};
const isAuthenticated = () => {
  if (auth.getToken() === null) {
    return false;
  }
  return true;
};

export { isAuthenticated, auth };



// WEBPACK FOOTER //
// ./src/components/Login/auth.js